module.exports = __webpack_public_path__ + "static/media/PG-Character-Sun-Heart.a0082d97.png";